import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { P404Component } from './404.component';
import { P500Component } from './500.component';
import { OfflineComponent } from './offline.component';

/**
 * The platform's error screens: 404, 500 and offline.
 *
 * Self-contained and NOT imported by BaseModule, deliberately. Each app opts in
 * with `imports: [ErrorModule]`, so adding this changed nothing for apps that
 * already declare their own copies — they can adopt it when they choose.
 *
 * These lived as an identical copy in every app that used them. Templates use
 * relative asset paths (`assets/...`, not `/assets/...`) so they resolve both at
 * the origin root and under a sub-path mount such as /tools.
 */
@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [P404Component, P500Component, OfflineComponent],
  exports: [P404Component, P500Component, OfflineComponent],
})
export class ErrorModule { }
